/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ads_Sold_OutInputs */

const en_directory_ads_sold_out = /** @type {(inputs: Directory_Ads_Sold_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sold out`)
};

const zh_directory_ads_sold_out = /** @type {(inputs: Directory_Ads_Sold_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已售罄`)
};

/**
* | output |
* | --- |
* | "Sold out" |
*
* @param {Directory_Ads_Sold_OutInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ads_sold_out = /** @type {((inputs?: Directory_Ads_Sold_OutInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ads_Sold_OutInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ads_sold_out(inputs)
	return zh_directory_ads_sold_out(inputs)
});
export { directory_ads_sold_out as "directory.ads.sold_out" }